module.exports = __webpack_public_path__ + "static/media/ajax-Loader.062cd8a6.gif";